import { apiRequests } from '../utilities/axios-factory'
import store from '../store'

function authHeaders () {
  return { Authorization: store.getters.getTokenId }
}

export function searchBeacons ({ healthStatus, protocol, manufacturer, key, order, limit, offset } = {}) {
  return apiRequests.get('/v1/beacon/search/', {
    params: {
      healthStatus: Array.isArray(healthStatus) ? healthStatus.join(',') : healthStatus,
      protocol: protocol || undefined,
      manufacturer: manufacturer || undefined,
      key: key || undefined,
      order,
      limit,
      offset
    },
    headers: authHeaders()
  }).then((result) => result.data)
}

export function getBeaconHistory (id) {
  return apiRequests.get('/v1/beacon/' + encodeURIComponent(id) + '/history/', {
    headers: authHeaders()
  }).then((result) => result.data)
}

export function addBeaconNote (id, note) {
  return apiRequests.post('/v1/beacon/' + encodeURIComponent(id) + '/note/', { note }, {
    headers: authHeaders()
  }).then((result) => result.data)
}

export function markBatteryReplaced (id, note, replacedAt) {
  return apiRequests.post('/v1/beacon/' + encodeURIComponent(id) + '/battery-replaced/', {
    note: note || undefined,
    replacedAt: replacedAt || undefined
  }, {
    headers: authHeaders()
  }).then((result) => result.data)
}
